import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="broken-image"
export default class extends Controller {
  static targets = ["image"]
  static values = { placeholder: String }

  error() {
    this.imageTarget.src = this.placeholderValue
    this.imageTarget.onerror = null
  }
}
